import React, {useEffect, useMemo, useRef, useState, createContext, useContext} from "react";
import '../../css/header.css';
import '../../css/auth.css';
import '../../css/crm.css';
import "../../css/search.css";
import "../../css/lightTheme/headerLight.css";

import {Link, useLocation} from "react-router-dom";
import {GoogleIcon, YandexIcon} from "../utils/Icons";
import {FeedBack} from "../crm/feedback";
import {Search} from "./Search";
import HeaderMenu from "./HeaderMenu";
import {Button} from 'antd';
import siteStructure from "../siteStructure.json";
import {findElementByLink} from "../utils/siteStructure";
import {SearchOutlined, CloseOutlined,  SunOutlined, MoonOutlined } from '@ant-design/icons';

// Картинки теперь в public → строковые URL.
const Logo = "/images/logo_white.svg";
const noAvatar = "/images/noAvatar.webp";

export default function Header() {

    const location = useLocation();
    const locationPath = location.pathname;

    const mail = localStorage.getItem('mail');
    const avatar = localStorage.getItem('avatar');
    const token = localStorage.getItem('token');

    const { theme, toggleTheme: contextToggleTheme } = useTheme();
    const [isAnimating, setIsAnimating] = useState(false);

    // Локальная функция-обёртка для запуска анимации перед переключением темы
    const handleToggleTheme = () => {
        setIsAnimating(true);
        contextToggleTheme(); // переключаем тему в контексте
    };

    const handleAnimationEnd = () => {
        setIsAnimating(false);
    };

    const [searchState, setSearchState] = useState(false)

    const classes = locationPath === '/'&& !searchState
        ? {
            header: 'headerHome',
            logo: 'logoHome',
            navMenu: 'nav-menuHome',
        }
        : {
            header: 'header',
            logo: 'logo',
            navMenu: 'nav-menu',
        };



    const menuLinks = useMemo(() => {

        const linksData = [
            {path: 'about'},
            {path: 'services'},
            {path: 'production', hasMegaMenu: true},
            {path: 'lizing'},
            {path: 'about/contacts'},
            {path: 'https://forum.sespel.su/posts/recent', label: 'Форум'},
            {path: 'vacancy', label: 'Вакансии'},
            {path: 'news'},
        ];

        linksData.forEach((e, i) => {

            let menuData = findElementByLink(siteStructure, e.path, true)
            if(menuData !== null) {
                linksData[i].label = menuData.title
                if(menuData.links){
                    linksData[i].links = menuData.links
                }
            }
        })
        return linksData

    }, [])

    useEffect(() => {
        if (searchState) {
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100vh';
        } else {
            document.body.style.overflow = 'auto';
            document.body.style.height = 'auto';
        }

        // Очистка при размонтировании компонента
        return () => {
            document.body.style.overflow = 'auto';
            document.body.style.height = 'auto';
        };
    }, [searchState]);

    return (
        <>
            <header className={`${classes.header} ${theme}`}>
                <FeedBack token={token}/>
                <div className="headerLogo">

                    <div className="contactInfo">
                        <div className="phone">+7 800 505-06-34</div>
                        <div className="phone">+7 835 222-57-22</div>
                        <div className="email">zaosespel@yandex.ru</div>
                    </div>
                    <Link to="/" className={classes.logo} onClick={() => setSearchState(false)}>
                        <img src={Logo} alt="Logo"/>
                    </Link>

                    <div className="headerContent">
                        <div
                            className={`theme-toggle ${isAnimating ? 'animate' : ''}`}
                            onClick={handleToggleTheme}
                            onAnimationEnd={handleAnimationEnd}
                        >
                            {theme === 'light' ? <MoonOutlined /> : <SunOutlined />}
                        </div>
                        {mail ? (
                            <>
                                <div className={"searchMailWrapper"}>
                                    <SearchButton setSearchState={setSearchState} searchState={searchState}/>
                                    <div className="textMail">{mail}</div>
                                </div>
                                <DropdownLogout mail={mail} avatar={avatar} setSearchState={setSearchState}/>
                            </>
                        ) : (
                            <>
                                <SearchButton setSearchState={setSearchState} searchState={searchState}/>
                                <DropdownLogin/>
                            </>
                        )}
                    </div>
                </div>
                <HeaderMenu menuLinks={menuLinks} classes={classes} setSearchState={setSearchState}/>
            </header>
            <Search searchState={searchState} setSearchState={setSearchState}/>
        </>
    );
}

export function SearchButton({setSearchState, searchState}){

    return (
        <Button
            type="text"
            onClick={() => setSearchState(!searchState)}
            className={"searchButton"}
            style={{
                height: '70%',
                color: '#fff', // Светлый цвет текста
                padding: '0 8px',
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                minWidth: 'auto',
                fontWeight: 'normal'
            }}
        >
            {searchState ? (
                <>
                    Закрыть поиск
                    <CloseOutlined/>
                </>
            ) : (
                <>
                    Поиск
                    <SearchOutlined/>
                </>
            )}
        </Button>
    )
}

function DropdownLogout({mail, avatar, setSearchState}) {

    const [dropDown, setDropdown] = useState(false)

    //Закрытие dropdown на клик вне поля
    const wrapperRef = useRef(null)
    useOutsideAlerter(wrapperRef, dropDown, setDropdown)

    function changeDropdown() {
        setDropdown(!dropDown)
    }

    return (
        <div ref={wrapperRef} className="dropdown">
            <div className="avatar" onClick={changeDropdown}>
                <img className="avatarImg" src={avatar? avatar : noAvatar} alt=""/>
            </div>
            <div className="dropdown-content" style={{display: `${dropDown ? "block" : "none"}`}}>
                <div className="avatarDropdown">
                    <img className="avatarDropdownImg" src={avatar? avatar : noAvatar} alt="" loading="lazy"/>
                </div>
                <div className="mailDropdown">{mail}</div>
                <div className={"buttonMyRequest"}>
                    <Link to={"/requests"} onClick={() => {
                        setSearchState(false)
                        setDropdown(false)
                    }}>
                        Мои заявки
                    </Link>
                </div>
                <div className="buttonLogout" onClick={logout}>Выйти</div>
            </div>
        </div>
    )
}

function DropdownLogin() {

    const [dropDown, setDropdown] = useState(false)

    //Закрытие dropdown на клик вне поля
    const wrapperRef = useRef(null)
    useOutsideAlerter(wrapperRef, dropDown, setDropdown)

    function changeDropdown() {
        setDropdown(!dropDown)
    }

    return (
        <div ref={wrapperRef} className="dropdown">
            <div className="buttonAuth" onClick={changeDropdown}>Войти</div>
            <div className="dropdown-login" style={{display: `${dropDown ? "block" : "none"}`}}>
                <div className="buttonLogin" onClick={authYandex}>
                    <YandexIcon/>
                    Войти через Яндекс ID
                </div>
                <div className="buttonLogin" onClick={authGoogle}>
                    <GoogleIcon/>
                    Войти через Google ID
                </div>
            </div>


            <div className={`darkSpace ${dropDown ? "darkSpaceVisible" : ""}`} onClick={() => {
                setDropdown(false)
            }}> </div>
        </div>
    )
}

function useOutsideAlerter(ref, dropDown, setDropdown) {
    useEffect(() => {

        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setDropdown(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [ref, setDropdown])
}

export function logout() {
    localStorage.setItem('mail', "")
    localStorage.setItem('token', "")
    localStorage.setItem('avatar', "")
    window.location.href = 'https://www.sespel.su/'
    // window.location.href = 'http://localhost:3000'
}

export function authYandex() {
    window.location.href = 'https://oauthya.sespel.su/loginYandex'
}

export function authGoogle() {
    window.location.href = 'https://oauthgoogle.sespel.su/login'
}

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('theme') || 'dark';
    });

    const toggleTheme = () => {
        setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
    };

    useEffect(() => {
        localStorage.setItem('theme', theme);
        // Применяем класс к body для глобальных стилей
        document.body.setAttribute('data-theme', theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) throw new Error('useTheme must be used within ThemeProvider');
    return context;
};